import { HYModuleManager } from "@hy-sdk/framework";
import UserApi from "./api/api";

namespace ModuleUser {

  export const module = HYModuleManager.createModule("user");
  export const Api = UserApi;
}

export default ModuleUser;